import {decodeTopojsonFeatures} from '../resources/utils';

export const getEvacZoneBbox = slug => {
  const fireWBbox = window.fireData.fireList.find(d => d.slug === slug.split(' ').join('-') && d.hasOwnProperty('evac_zone_bbox'));
  if(fireWBbox){
    return fireWBbox.evac_zone_bbox;
  } else {
    return;
  }
}

export const addEvacuationZonesDetailLayer = () => {
  addEvacuationZonesLayer();
}

export const addEvacuationZonesIndexLayer = () => {
  addEvacuationZonesLayer();
  window.fireMap.addLayer({
    'id': 'evacuation-labels',
    'type': 'symbol',
    'source': {
      "type": "geojson",
      "data": window.fireData.evacuationZones
    },
    "layout": {
      'text-field': ['get', 'label'],
      'text-variable-anchor': ['center'],
      'text-font': ['Overpass Mono SemiBold'],
      'text-size': {
        base: 0,
        stops: [[1, 0], [9, 0], [10, 9], [11.6, 14]],
      },
      'text-padding': {
        base: 15,
        stops: [[1, 10], [8, 20]],
      },
      'text-allow-overlap': true,
      'text-optional': false
    },
    "paint": {
      'text-color': "#fff",
      'text-halo-color': [
        'match',
        ['string', ['get', 'mandatory']],
        'true', '#800c03',
        'false', '#e6a100',
        '#ccc'
      ],
      'text-halo-width': 1.5,
    }
  }, 'state-label');
}

const addEvacuationZonesLayer = () => {
  window.fireMap.addLayer({
    id: `evacuation-zones`,
    type: 'fill',
    source: {
      type: 'geojson',
      data: window.fireData.evacuationZones,
    },
    layout: {},
    paint: {
      'fill-opacity': [
        "interpolate", ["linear"], ["zoom"],
        6, 0,
        7.5, 0.15,
        9, 0.28
      ],
      'fill-color': [
        'match',
        ['string', ['get', 'mandatory']],
        'true', '#cc1100',
        'false', '#ffc908',
        '#ccc'
      ]
    }
  }, 'water-point-label');

  window.fireMap.addLayer({
    id: `evacuation-zones-outline`,
    type: 'line',
    source: {
      type: 'geojson',
      data: window.fireData.evacuationZones,
    },
    layout: {},
    paint: {
      'line-color': [
        'match',
        ['string', ['get', 'mandatory']],
        'true', '#cc1100',
        'false', '#ffc908',
        '#ccc'
      ],
      'line-width': [
        "interpolate", ["linear"], ["zoom"],
        6, 0,
        7.5, .5,
        12, .6
      ],
      'line-opacity': [
        "interpolate", ["linear"], ["zoom"],
        6, 0,
        7.5, .3,
        9, 0.5
      ]
    }
  }, 'fire-shapes');
}
